"use client";

import { useEffect, useState } from "react";
import styles from "./index.module.css";
import AuthForm from "../auth/AuthForm";

const ChatAuth = ({
  chatInfo,
  closeChat,
  activateGuestMode,
  onLoadStage = 1,
  handleAuthSuccess,
}) => {
  const [stage, setStage] = useState(onLoadStage);
  const [isNewUser, setIsNewUser] = useState(false);

  useEffect(() => {
    setStage(onLoadStage);
  }, [onLoadStage]);

  return (
    <div className={styles.notLoggedIn}>
      {stage === 1 && (
        <>
          <div className={styles.emptyText}>Hi, there</div>
          <p>
            Do you want to chat with an admin representative of {chatInfo?.name}
            ?
          </p>
          <div className={styles.actions}>
            <button
              className={`${styles.btn} ${styles.btnBlue}`}
              onClick={() => setStage(2)}
            >
              Yes
            </button>
            <button
              className={`${styles.btn} ${styles.btnTransparent}`}
              onClick={closeChat}
            >
              No
            </button>
          </div>
        </>
      )}

      {stage === 2 && (
        <>
          <p>Do you have a Circleplug account?</p>
          <div className={styles.actions}>
            <button
              className={`${styles.btn} ${styles.btnBlue}`}
              onClick={() => setStage(3)}
            >
              Yes, log me in
            </button>
            <button
              className={`${styles.btn} ${styles.btnTransparent}`}
              onClick={() => {
                setIsNewUser(true);
                setStage(3);
              }}
            >
              No, sign me up
            </button>
          </div>
          <div className={styles.guestWrapper}>
            <button
              className={`${styles.btn} ${styles.btnSubtle}`}
              onClick={() => {
                activateGuestMode?.();
              }}
            >
              Continue as Guest
            </button>
          </div>
        </>
      )}

      {stage === 3 && (
        <AuthForm
          defaultLogin={!isNewUser}
          chatLogin="chat-login-display"
          onLogin={handleAuthSuccess}
        />
      )}
    </div>
  );
};

export default ChatAuth;
